<svg
  [class]="customClass()"
  [class.caret-icon--open]="isOpen()"
  class="caret-icon"
  [attr.width]="width()"
  [attr.height]="height()"
  [style.color]="color()"
  [style.transform]="'rotate(' + (isOpen() ? openRotation() : closedRotation()) + 'deg)'"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.7333 6.9333L8 10.9333L12.2667 6.9333"
    stroke="currentColor"
    stroke-width="1.0667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
